import React from 'react';
import { Strong } from 'evergreen-ui';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  summary: {
    cursor: 'pointer',
  }
});
export default function Details({ label, children }) {
  const classes = useStyles()
  return (
    <details>
      <summary className={classes.summary}><Strong color="#00783E">{label}</Strong></summary>
      {children}
    </details>
);
}
